import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_replenishment_run_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_algo: fromDatatype.GuidDataFieldInterface;
  run_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  event_hdr_guid: fromDatatype.GuidDataFieldInterface;
  prev_run_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_inv_stock_replenishment_run_hdr_RowClass
  implements bl_inv_stock_replenishment_run_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  guid_algo: fromDatatype.GuidDataFieldInterface;
  run_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  event_hdr_guid: fromDatatype.GuidDataFieldInterface;
  prev_run_guid: fromDatatype.GuidDataFieldInterface;
}
